module.exports = __webpack_public_path__ + "img/regular.2449f4ea.png";